module.exports = __webpack_public_path__ + "img/tuceng16.e15dd7e5.png";